document.addEventListener("DOMContentLoaded", () => {

    for (const container of document.querySelectorAll(".sc-read-more")) {

        // Because of autop we can't assume that the parent of the button is
        // the container, so we query both elements and attach the container directly to
        // the button, so this will also work if the button is wrapped in a p element.
        const button = container.querySelector(".sc-read-more__button");

        const content = container.querySelector(".sc-read-more__content");

        if (button && content) {

            button.read_more_container = container;
            button.read_more_content = content;

            button.addEventListener("click", e => toggle_read_more_expand(e));

            content.addEventListener("transitionend", e => reset_after_expand_transition(e));

        }

    }


});


function toggle_read_more_expand(e) {

    // Disable the toggle button
    e.currentTarget.setAttribute("disabled", true);

    const container = e.currentTarget.read_more_container;
    const content = e.currentTarget.read_more_content;

    // If the container is collapsed
    if (container.classList.contains("sc-read-more--collapsed")) {

        // Compute the un-collapsed height,
        // then set the result as the new max-height
        content.style.maxHeight = content.scrollHeight + "px";

        container.classList.remove("sc-read-more--collapsed");

    } else {

        // Since the max-height has been set to none after expanding, we have to set a value again in order to
        // animate to the collapsed max-height.
        content.style.maxHeight = content.getBoundingClientRect().height + "px";

        // We can't use this value immediately, so we have to wait until the browser has applied the style
        // and is ready for the next steps.
        requestAnimationFrame(() => {

            content.style.maxHeight = 0;

            container.classList.add("sc-read-more--collapsed");

        });

    }

}

function reset_after_expand_transition(e) {

    // If some other animation is bubbling up (e.g. the button rotation), ignore it and return.
    // (Assume that there is no other max-height transition.)
    if (e.propertyName !== "max-height") {
        return;
    }

    const elem = e.currentTarget;

    const container = elem.parentNode;

    const button = container.querySelector(".sc-read-more__button");

    // enable the toggle button again
    button.removeAttribute("disabled");


    // If the container just has expanded (then it no longer has the according class),
    // set the max-height to none so all will be visible even if e.g. the height changes.
    // Also toggle the button text.
    if (!container.classList.contains("sc-read-more--collapsed")) {
        elem.style.maxHeight = "none";
        button.innerHTML = button.dataset.less_text;
    } else {
        button.innerHTML = button.dataset.more_text;
    }

}